import React, { useEffect, useState } from "react"
import { Box, CSSGrid, FlexGrid, NotificationHub } from "@nef/core"
import { useDispatch, useSelector } from "react-redux"

import StyledAbout from "../../../../styles/About.styles"
import { NFN_OPS_EMAIL_HREF, NFN_OPS_TEL, NFN_OPS_TEL_HREF } from "../../../../constants/common"
import MarketHolidays from "../../../../modules/MarketCloseCalendar/MarketHolidays"
import { AppDispatch, RootState } from "../../../../app/store"
import { getMarketHolidays } from "../../../../utils/datetimehandler"

import RegistrationButton from "./RegistrationButton"
import SizzleVideo from "./SizzleVideo"
import InstrumentList from "./InstrumentList"


const About = () => {
  const nasdaqHolidays = useSelector((_state: RootState) => _state.utilities.nasdaqHolidays)
  const customHolidays = useSelector((_state: RootState) => _state.utilities.customHolidays)
  const [isCalendarFetching, setIsCalendarFetching] = useState<boolean>(false)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (!nasdaqHolidays?.length && !customHolidays?.length) {
      getMarketHolidays(dispatch, setIsCalendarFetching)
    }
  }, [])

  return (
    <>
      <NotificationHub />
      <StyledAbout id="about">
        <FlexGrid.Row className="top-row">
          <FlexGrid.Column sm={18} md={16} lg={14} xl={16}>
            <h3>About NFN</h3>
            <p>
              The Nasdaq Fund Network (NFN) facilitates the collection and dissemination of performance, NAV, valuation, and strategy-level reference
              data for over 35,000 investable products to 100 million plus investors. Members of the service register their products on the network and
              receive a unique symbol. The service then disseminates the data, making it searchable on one of the largest distribution channels, which
              pipes into online brokerages and major market data vendors. Product issuers and asset managers benefit from an automated service that
              helps bring more awareness to and gather assets for new and existing products. Also, both institutional and retail investors, as well as
              the general investing public, benefit from daily access to transparent fund-level data for a wide range of products to help inform
              investment decisions.
            </p>
            <SizzleVideo />
          </FlexGrid.Column>
          <FlexGrid.Column sm={6} md={8} lg={10} xl={8}>
            {" "}
            <h3>Join NFN</h3>
            <p>Register your organization as an Issuer, Administrator, or Pricing Agent.</p>
            <p>
              Data vendor please contact <a href="mailto:dataproducts@nasdaq.com">dataproducts@nasdaq.com</a> with inquiries regarding NFN Data Service
              or NFNDS via NCDS.
            </p>
            <RegistrationButton>Register</RegistrationButton>
            <CSSGrid className="content-right">
              <Box className="link-group">
                <h3>Guide to NFN</h3>
                <ul>
                  <li>
                    <a href="http://www.nasdaqtrader.com/Trader.aspx?id=MFQSSpecs" target="_blank" rel="noopener noreferrer">
                      {" "}
                      NFN Technical Specifications{" "}
                    </a>
                  </li>
                  <li>
                    <a href="http://www.nasdaqtrader.com/Trader.aspx?id=DPPriceListFunds" target="_blank" rel="noopener noreferrer">
                      {" "}
                      NFN Price List{" "}
                    </a>
                  </li>
                  <li>
                    <a href="http://www.nasdaqtrader.com/content/administrationsupport/nfn_faqs.pdf" target="_blank" rel="noopener noreferrer">
                      {" "}
                      NFN FAQs{" "}
                    </a>
                  </li>
                  <li>
                    <a href="mailto:Accounts.Receivable@nasdaq.com" target="_blank" rel="noopener noreferrer">
                      {" "}
                      Nasdaq Invoice inquiry{" "}
                    </a>
                  </li>
                </ul>
              </Box>
              <Box className="link-group">
                <h3>Issuers & Pricing Agents</h3>
                <ul>
                  <li>
                    <a href="http://www.nasdaqtrader.com/Trader.aspx?id=MFQS" target="_blank" rel="noopener noreferrer">
                      {" "}
                      NFN Agreements & Forms{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=e0e21a6d-22ad-45a1-b1d3-bfb88ae485b8&env=na2&acct=b82883ed-5c0f-426e-877d-367a29bfd959&v=2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      NFN Firm Set Up / Logon Request Form{" "}
                    </a>
                  </li>
                  <li>
                    <a href="http://www.nasdaqtrader.com/Trader.aspx?id=archiveheadlines&cat_id=19" target="_blank" rel="noopener noreferrer">
                      {" "}
                      NFN News{" "}
                    </a>
                  </li>
                  <li>
                    <a href="/symbol_generator" target="_blank" rel="noopener noreferrer">
                      {" "}
                      Symbol Generator{" "}
                    </a>
                  </li>
                </ul>
              </Box>
              <Box className="link-group">
                <h3>Market Data Vendors</h3>
                <ul>
                  <li>
                    <a href="http://www.nasdaqtrader.com/Trader.aspx?id=AgreementsData" target="_blank" rel="noopener noreferrer">
                      {" "}
                      Global Data Agreements & Forms{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=e0e21a6d-22ad-45a1-b1d3-bfb88ae485b8&env=na2&acct=b82883ed-5c0f-426e-877d-367a29bfd959&v=2" target="_blank" rel="noopener noreferrer">
                      {" "}
                      Nasdaq Data Web Logon Request Form{" "}
                    </a>
                  </li> 
                  <li>
                    <a href="http://www.nasdaqtrader.com/Trader.aspx?id=archiveheadlines&cat_id=5" target="_blank" rel="noopener noreferrer">
                      {" "}
                      Data News{" "}
                    </a>
                  </li>
                  <li>
                    <a href="http://www.nasdaqtrader.com/Trader.aspx?id=archiveheadlines&cat_id=48" target="_blank" rel="noopener noreferrer">
                      {" "}
                      Data Technical News{" "}
                    </a>
                  </li>
                </ul>
              </Box>
            </CSSGrid>
          </FlexGrid.Column>
        </FlexGrid.Row>
        <FlexGrid.Row>
          <FlexGrid.Column sm={18} md={16} lg={14} xl={16}>
            <h3>Overview</h3>
            <p>
              Operated by Nasdaq Inc, the NFN system facilitates the collection and dissemination of valuation data for the following asset classes:
            </p>
            <InstrumentList />
          </FlexGrid.Column>
        </FlexGrid.Row>
        <FlexGrid.Row>
          <MarketHolidays
            nasdaqHolidays={nasdaqHolidays}
            customHolidays={customHolidays}
            getMarketHolidays={getMarketHolidays}
            isCalendarFetching={isCalendarFetching}
            viewOnly
          />
        </FlexGrid.Row>
        <FlexGrid.Row>
          <FlexGrid.Column sm={18} md={16} lg={14} xl={16}>
            <h3>Contact Information</h3>
            <div>
              <p>
                General NFN inquiries should be directed to <a href={NFN_OPS_EMAIL_HREF}> Nasdaq Fund Network Operations </a> at{" "}
                <a href={NFN_OPS_TEL_HREF}>{NFN_OPS_TEL}</a>.
              </p>
            </div>
          </FlexGrid.Column>
        </FlexGrid.Row>
      </StyledAbout>
    </>
  )
}

export default About
